/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Offset_AddInputs */

const en_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const fr_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const it_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungere`)
};

const ru_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлять`)
};

const es_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const zh_cn2_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const ja_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const hi_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ना`)
};

const pt_pt2_subtitle_export_offset_add = /** @type {(inputs: Subtitle_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Subtitle_Export_Offset_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_offset_add = /** @type {((inputs?: Subtitle_Export_Offset_AddInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Offset_AddInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_offset_add(inputs)
	if (locale === "de") return de_subtitle_export_offset_add(inputs)
	if (locale === "it") return it_subtitle_export_offset_add(inputs)
	if (locale === "ru") return ru_subtitle_export_offset_add(inputs)
	if (locale === "es") return es_subtitle_export_offset_add(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_offset_add(inputs)
	if (locale === "ja") return ja_subtitle_export_offset_add(inputs)
	if (locale === "hi") return hi_subtitle_export_offset_add(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_offset_add(inputs)
	return en_subtitle_export_offset_add(inputs)
});